import HekateOptionsListElement from './HekateOptionListElement';
export default class HekateOptionList {
    constructor({ id, name, elements, }) {
        this.id = id;
        this.elements = elements || [];
        this.name = name;
    }
    /**
     * Shuffle elements in place, but leave the first element untouched as it is typically the choose
     * return `this`;
     */
    shuffleElements() {
        const elements = [...this.elements.slice(1)].sort(() => Math.random() - 0.5);
        for (let ii = 1; ii < this.elements.length; ii += 1) {
            this.elements[ii] = elements[ii - 1];
        }
    }
    static newEmptyList() {
        return new HekateOptionList({
            id: '',
            name: 'hekate-empty',
            elements: [],
        });
    }
    static fromBlob(blob) {
        const id = blob.id;
        const name = blob.name || 'Unknown Option List Name';
        const elements = typeof blob.elements !== 'undefined' ?
            blob.elements.map((elmBlob) => HekateOptionsListElement.fromBlob(elmBlob))
            : [];
        return new HekateOptionList({
            name,
            id,
            elements,
        });
    }
    /** Logically compare (suitable for serialization check) */
    compareTo(rhs) {
        return (this.id === rhs.id &&
            this.name === rhs.name &&
            this.elements.length === rhs.elements.length &&
            !this.elements.find((elm, ii) => !elm.compareTo(rhs.elements[ii])));
    }
}
